/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, scope: NonNullable<unknown> }} Calendar_Sync_SummaryInputs */

const cs_calendar_sync_summary = /** @type {(inputs: Calendar_Sync_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Synchronizovat ${i?.count} viditelných úkolů · ${i?.scope}`)
};

const en_calendar_sync_summary = /** @type {(inputs: Calendar_Sync_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sync ${i?.count} visible tasks · ${i?.scope}`)
};

/**
* | output |
* | --- |
* | "Sync {count} visible tasks · {scope}" |
*
* @param {Calendar_Sync_SummaryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_sync_summary = /** @type {((inputs: Calendar_Sync_SummaryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Sync_SummaryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_sync_summary(inputs)
	return cs_calendar_sync_summary(inputs)
});